import { EnhancedPayrollReport } from '@reporting/interfaces/report.interface';
import { getInitialDatesForYTD } from '../dates';

export const RqRemittance: EnhancedPayrollReport = {
    name: 'reporting.payroll.rqRemittance.name',
    description: 'reporting.payroll.rqRemittance.description',
    routerLink: 'revenue-quebec-remittance',
    reportName: 'rqRemittanceReport',
    fileName: '???',
    hasExcel: true,
    hasPDF: false,
    hasCSV: false,
    allowsInclusionOfPendingPayrolls: false,
    showsPeriod: false,
    filterable: true,
    isAnnual: false,

    getInitialDates: getInitialDatesForYTD,
};
